import React, { ReactNode, useState } from 'react';
import clsx from 'clsx';
import Panel from '../../styled/Panel';

interface INestedPanel {
  onClose: () => void;
  children: (
    step: string,
    stepHistory: string[],
    goToStep: (newStep: string) => void,
    goBack: () => void,
    onClose: () => void,
  ) => ReactNode;
  initialStep: string;
  noBodyPadding?: boolean;
}

export default function NestedPanel({
  onClose,
  children,
  initialStep,
  noBodyPadding,
}: INestedPanel) {
  const [stepHistory, setStepHistory] = useState<string[]>([initialStep]);
  const [step, setStep] = useState(initialStep);

  const goToStep = (newStep: string) => {
    if (newStep !== step) {
      setStep(newStep);
      setStepHistory((prev) => [...prev, newStep]);
    }
  };

  const goBack = () => {
    if (stepHistory.length > 1) {
      setStep(stepHistory[stepHistory.length - 2]);
      setStepHistory((prev) => prev.slice(0, -1));
    }
  };

  return (
    <Panel
      className={clsx(noBodyPadding && 'no-body-padding')}
      onBackClick={stepHistory.length > 1 ? goBack : undefined}
      onClose={onClose}>
      {children(step, stepHistory, goToStep, goBack, onClose)}
    </Panel>
  );
}
